/**
 * Business facts that appear in static markup.
 *
 * Anything the studio can change from the admin page - prices, hours, deposit
 * percentage - is fetched from /api/studio at runtime instead. What lives here
 * is only the genuinely fixed detail.
 *
 * The address is deliberately partial. This is a treatment room in someone's
 * home, so the street and full postcode are not published anywhere public -
 * they go out in the booking confirmation email, once there is an appointment
 * to come to. Keep it that way: the full address lives in the API config, which
 * only the email templates read.
 */
export const STUDIO = {
  name: 'The Renewal Studio',
  addressLines: ['Finchampstead, Berkshire', 'RG40'],
  phoneDisplay: '07809 888733',
  phoneHref: '+447809888733',
  instagram: 'the_renewal_studio',
  website: 'https://www.therenewalstudio.co.uk',
  bookingUrl: 'https://l.fresha.com/3tvss7q28',
  /** Points at the village, not the door. */
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Finchampstead%2C+Berkshire',
  /** Only used before /api/studio has responded. */
  depositPercentFallback: 50,
  /** Likewise: the notice, in hours, for a refunded deposit. */
  cancellationHoursFallback: 24,
} as const;
